import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../components/footer/footer.component';
import { StaticSearchComponent } from '../../../components/static-search/static-search.component';
import { CommonHeaderComponent } from '../../../components/common-header/common-header.component';
import { PDSService } from '../../../services/pds.service';
@Component({
  selector: 'app-how-to-claim',
  standalone: true,
  imports: [FooterComponent, StaticSearchComponent, CommonHeaderComponent],
  templateUrl: './how-to-claim.component.html',
  styleUrl: './how-to-claim.component.scss',
})
export class HowToClaimComponent {
  partnerCode: string = '';
  constructor(
    private titleService: Title,
    private metaService: Meta,
    public pdsService: PDSService,
  ) {
    this.titleService.setTitle(
      'How To Claim Travel Insurance Online | World2Cover Australia',
    );
    this.metaService.updateTag({
      name: 'description',
      content: `You can make a travel insurance claim online with World2Cover. Track your claim status with ease. Submit within 30 days of your trip.`,
    });
    this.metaService.updateTag({
      property: 'og:title',
      content: 'How To Claim Travel Insurance Online | World2Cover Australia',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content:
        'You can make a travel insurance claim online with World2Cover. Track your claim status with ease. Submit within 30 days of your trip.',
    });
    this.partnerCode = this.pdsService.getWhiteLabelPartnerCode();
  }
}
